import { CommonUtility } from '@utility/common';
import { APIPath } from '../constants';
import { BaseService } from './base';
import { CRUDService } from './crud.ts';

class Shipments extends CRUDService {
  constructor() {
    super(APIPath.shipments);
  }

  checkInShipment(id, payload) {
    return BaseService.post(`${APIPath.shipments}/${id}/checkin`, payload);
  }

  checkQuantities(id, payload) {
    return BaseService.post(`${APIPath.shipments}/${id}/check-quantities`, payload);
  }

  changeStatus(id, payload) {
    return BaseService.put(`${APIPath.shipmentsStatus}/${id}/  `, payload);
  }

  addComment(id, payload) {
    return BaseService.post(`${APIPath.shipmentsComment}/${id}`, payload);
  }

  getDocumentUploadUrl(params) {
    return BaseService.get(
      `${APIPath.shipmentsDocumentsUploadUrl}?${CommonUtility.objectToParams(params)}`,
    );
  }

  uploadShipmentDocuments(payload) {
    return BaseService.post(APIPath.shipmentsUploadShipmentDocuments, payload);
  }

  updateAttentionEmails(id, payload) {
    return BaseService.put(`${APIPath.shipments}/${id}/attention-emails`, payload);
  }
}

const ShipmentsService = new Shipments();
Object.freeze(ShipmentsService);
export { ShipmentsService };
